const appointmentWizardStepKeys = {
  REQUIREMENTS: 'requirements',
  DATE_AND_TIME: 'dateAndTime',
  IDENTIFICATION: 'identification',
  CONFIRMATION: 'confirmation'
};

const appointmentAssistanceTypeCodes = {
  PRESENTIAL: 'false',
  VIDEOCALL: 'true'
};

const appointmentAssistanceTypeIcons = {
  [appointmentAssistanceTypeCodes.PRESENTIAL]: 'icosun-map',
  [appointmentAssistanceTypeCodes.VIDEOCALL]: 'icosun-simple_videocall'
};

const appointmentAssistanceTypeName = {
  [appointmentAssistanceTypeCodes.PRESENTIAL]: 'SI_PRESENTIAL',
  [appointmentAssistanceTypeCodes.VIDEOCALL]: 'SI_TELECONSULTATION'
};

const appointmentInsuranceIdentificationType = {
  CARD_NUMBER: 'CARD_NUMBER',
  LOCATOR: 'LOCATOR',
};

const appointmentVoucherIdentificationType = {
  CARD_OR_CASH: 'CARD_OR_CASH',
  VOUCHER: 'VOUCHER',
};

const appointmentProofDeliveryMethod = {
  WEB: 'WEB',
  EMAIL: 'EMAIL'
};

const appointmentLinkVerificationCodes = {
  SMS: 'SMS',
  EMAIL: 'EMAIL'
};

const appointmentDownloadOptionIds = {
  PROOF: -1
};

const appointmentDownloadOptionActions = {
  PROOF: 'DOWNLOAD_PROOF',
  IC: 'HAS_INFORMED_CONSENT'
};

const appointmentDownloadOptionPermissions = {
  PROOF: 'appointment_management:download_proof',
  IC: 'appointment_management:download_ic'
};

const appointmentDownloadOptionNames = {
  PROOF: 'SI_APPOINTMENT_PROOF'
};

const appointmentDownloadOptionValues = {
  PROOF: {
    id: appointmentDownloadOptionIds.PROOF,
    name: appointmentDownloadOptionNames.PROOF
  }
};

const appointmentStateCodes = {
  SCHEDULED: 'SCHEDULED',
  ARRIVED: 'ARRIVED',
  ATTENDING: 'ATTENDING',
  ATTENDED: 'ATTENDED',
  PATIENT_HAS_LEAVE: 'PATIENT_HAS_LEAVE',
  PENDING_RESCHEDULING: 'PENDING_RESCHEDULING',
  RESCHEDULED: 'RESCHEDULED',
  CANCELLED: 'CANCELLED',
  PATIENT_CALLED: 'PATIENT_CALLED',
  PENDING_RESCHEDULING_SCHEDULE: 'PENDING_RESCHEDULING_SCHEDULE',
  ATTENDED_ADMISSION: 'ATTENDED_ADMISSION',
  ABSENT: 'ABSENT',
  UNREALIZED: 'UNREALIZED',
  NOT_ATTENDED: 'NOT_ATTENDED'
};

const appointmentExcludedStates = [
  appointmentStateCodes.PENDING_RESCHEDULING,
  appointmentStateCodes.RESCHEDULED,
  appointmentStateCodes.CANCELLED,
  appointmentStateCodes.PENDING_RESCHEDULING_SCHEDULE
];

const appointmentSlotSearchOptions = {
  ALL: 'ALL',
  CENTER: 'CENTER',
  SERVICE: 'SERVICE',
  PROFESSIONAL: 'PROFESSIONAL'
};

const appointmentNoticeCategories = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

const appointmentNoticeCategoriesClass = {
  [appointmentNoticeCategories.HIGH]: 'error',
  [appointmentNoticeCategories.MEDIUM]: 'warning',
  [appointmentNoticeCategories.LOW]: 'success'
};

export {
  appointmentWizardStepKeys,
  appointmentStateCodes,
  appointmentAssistanceTypeCodes,
  appointmentAssistanceTypeIcons,
  appointmentAssistanceTypeName,
  appointmentProofDeliveryMethod,
  appointmentLinkVerificationCodes,
  appointmentDownloadOptionIds,
  appointmentDownloadOptionActions,
  appointmentDownloadOptionPermissions,
  appointmentDownloadOptionValues,
  appointmentExcludedStates,
  appointmentSlotSearchOptions,
  appointmentInsuranceIdentificationType,
  appointmentVoucherIdentificationType,
  appointmentNoticeCategories,
  appointmentNoticeCategoriesClass
};
